import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "antd";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { Input, Button, Box } from "components";
import { SendCompleteIcon } from "icons";
import { localStorageHelper } from "utils";
import { PASSWORD_REGEX } from "constant";
import { WrapperErrorMessage, ErrorMessage } from "theme/CommonStyle";

import { ChangePasswordData } from "models/changePassword";
import { ChangePasswordActionCreators } from "redux/rootActions";

import {
  selectIsChangingPassword,
  ChangePasswordDataResponse,
  selectIsSaved,
  selectChangePasswordErrorMessage,
} from "redux/changePassword/changePasswordStates";

import {
  WrapperSection,
  WrapperTitle,
  FormTitle,
  PasswordContainer,
  FormWrapper,
} from "screens/changePassword/ChangePassword.style";

const schema = yup.object().shape({
  oldPassword: yup.string().required("パスワードを入力してください"),
  newPassword: yup
    .string()
    .required("新しいパスワードを入力してください")
    .matches(
      PASSWORD_REGEX,
      "10文字以上、英大・小文字、数字、記号（推奨）を含むパスワードを作成してください"
    ),
  confirmPassword: yup
    .string()
    .required("確認用のパスワードを入力してください")
    .oneOf([yup.ref("newPassword")], "パスワードが一致しません"),
});

const GeneralSetting = () => {
  const dispatch = useDispatch();
  const changingPassword = useSelector(selectIsChangingPassword);

  const changePasswordData = useSelector(ChangePasswordDataResponse);
  const passwordChanged = useSelector(selectIsSaved);
  const changePasswordErrorMessage = useSelector(
    selectChangePasswordErrorMessage
  );

  const { handleSubmit, control, watch, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const [errorPassword, setErrorPassword] = useState<string>("");

  const watchOldPassword = watch("oldPassword");

  const onSubmitPasswords = (data: any) => {
    const params: ChangePasswordData = {
      current_password: data.oldPassword,
      new_password: data.newPassword,
      confirm_new_password: data.confirmPassword,
    };
    dispatch(ChangePasswordActionCreators.changePasswordAction(params));
  };

  useEffect(() => {
    if (changePasswordData && changePasswordData.message && passwordChanged) {
      notification.success({
        placement: "bottomRight",
        message: "パスワードは変更されました。",
        icon: <SendCompleteIcon />,
      });
      setValue("oldPassword", "");
      setValue("newPassword", "");
      setValue("confirmPassword", "");
      dispatch(ChangePasswordActionCreators.handleResetDataAction());
    }
  }, [passwordChanged, changePasswordData]);

  useEffect(() => {
    if (changePasswordErrorMessage) {
      setErrorPassword(changePasswordErrorMessage);
      dispatch(ChangePasswordActionCreators.handleResetDataAction());
    }
  }, [changePasswordErrorMessage]);

  useEffect(() => {
    if (watchOldPassword) {
      setErrorPassword("");
    }
  }, [watchOldPassword]);

  useEffect(() => {
    setErrorPassword("");
    dispatch(ChangePasswordActionCreators.handleResetDataAction());
  }, []);

  return (
    <>
      {/* <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          lineHeight: "23.17px",
        }}
      >
        各種設定
      </div> */}
      <FormWrapper>
        <form onSubmit={handleSubmit(onSubmitPasswords)}>
          {/* <div className="password-title">パスワード変更</div> */}
          <PasswordContainer>
            <div style={{ position: "relative" }}>
              <Controller
                control={control}
                name="oldPassword"
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Input
                    label="古いパスワード"
                    height={32}
                    fsLabel={16}
                    marginForm="0 0 16px 0"
                    lhLabel="16px"
                    value={value}
                    onChange={onChange}
                    error={error && error.message}
                    type="password"
                  />
                )}
              />
              {errorPassword && (
                <WrapperErrorMessage style={{ position: "relative", top: -10 }}>
                  <ErrorMessage>{errorPassword}</ErrorMessage>
                </WrapperErrorMessage>
              )}
            </div>
            <Controller
              control={control}
              name="newPassword"
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Input
                  label="新しいパスワード"
                  height={32}
                  fsLabel={16}
                  lhLabel="16px"
                  marginForm="0 0 16px 0"
                  value={value}
                  onChange={onChange}
                  error={error && error.message}
                  type="password"
                />
              )}
            />
            <Controller
              control={control}
              name="confirmPassword"
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Input
                  label="新しいパスワード（確認）"
                  height={32}
                  fsLabel={16}
                  lhLabel="16px"
                  marginForm="0 0 0 0"
                  value={value}
                  onChange={onChange}
                  error={error && error.message}
                  type="password"
                />
              )}
            />
          </PasswordContainer>
          <Button
            type="submit"
            name="保存"
            background="#2AC769"
            color="#FFFFFF"
            border="none"
            fontSize={16}
            fontWeight={700}
            lineHeight="23px"
            padding="4px 16px"
            margin="32px 0px 0px"
            width="64px"
            style={{ height: 31 }}
            disabled={changingPassword}
            loading={changingPassword}
          />
        </form>
      </FormWrapper>
    </>
  );
};

export default GeneralSetting;
